import type { I18n } from '@lingui/core';

import type { AgentText, ScreenManifest } from './types';

/** Resolve o texto do agente no idioma ativo (U46); `string` (dívida) passa como veio. */
export function resolveAgentText(i18n: I18n, text: AgentText): string {
  return typeof text === 'string' ? text : i18n._(text);
}

/** Texto-fonte, para validar tamanho sem depender do catálogo carregado. */
export function agentTextSource(text: AgentText): string {
  return typeof text === 'string' ? text : (text.message ?? text.id);
}

/** A tela ou alguma ação ainda descreve em `string` (dívida da U46). */
export function hasStringDescription(manifest: ScreenManifest): boolean {
  return typeof manifest.description === 'string' || manifest.actions.some((a) => typeof a.description === 'string');
}
